import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/content";
import { MaskLines, Overline, Reveal } from "@/components/site/Reveal";

export const Faq = () => (
  <section id="faq" className="relative mx-auto max-w-[1440px] px-5 py-28 sm:px-8 lg:px-12 lg:py-40" data-testid="faq-section">
    <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Overline>Frequently Asked</Overline>
        <MaskLines
          lines={["Questions,", <><em className="italic text-rc-copper">answered.</em></>]}
          className="mt-8 font-display text-4xl font-medium leading-[1.02] tracking-tight text-rc-ink sm:text-5xl lg:text-6xl"
        />
        <Reveal className="mt-8 max-w-sm text-base leading-relaxed text-rc-body">
          Still curious? Write to{" "}
          <a href="mailto:admin@rhettco.org" className="text-rc-copper underline-offset-4 hover:underline" data-testid="faq-email-link">
            admin@rhettco.org
          </a>
          .
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-rc-line">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-b border-rc-line">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-7 text-left font-display text-2xl font-medium text-rc-ink hover:no-underline hover:text-rc-copper sm:text-3xl [&>svg]:text-rc-copper"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-7 text-base leading-relaxed text-rc-body">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
